export default "__VITE_ASSET__BQHAe72x__"